module.exports = __webpack_public_path__ + "static/img/logo.df39b09d.png";